import React from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import AvatarCard from "./common/AvatarCard";
import partnerList from "./common/partnerList"; // This is data mockup and it will be deleted after provided with real data

export default function Testimonial() {
  return (
    <>
      <Box width="75%" mx="auto">
        <Typography component="p" variant="h2" color="primary" align="center">
          Currently, Ford sells six sedans and coupes in North America with the
          Fiesta, Focus, Fusion, C-Max, Mustang and Taurus. This lineup hits.
        </Typography>
      </Box>
      <Box width="25%" mx="auto" my={6}>
        <AvatarCard {...partnerList[0]} />
      </Box>
    </>
  );
}
